export const blockIconsSocialTravelExplore = (
	<span className='material-symbols-outlined'>travel_explore</span>
);
